import styled from "styled-components";
import { Link as BaseLink } from "react-router-dom";

export const Wrapper = styled.div`
    display: flex;
    flex-flow: row wrap;
    justif-content: flex-start;
    align-items: center;
    gap: 8px;

    & > :is(div,a):last-child{
        color: #8F97B2;
        pointer-events: none;
        & > a{
            color: #8F97B2;
        }
    }
`;

export const Link = styled(BaseLink)`
    color: #666B7D;
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
    text-decoration: none;
    &.capitalize{
        text-transform: capitalize;
    }
`;

export const ArrowImage = styled.img`
    width: 18px;
    height: 18px;
`

export const CapitalizeText = styled.div`
    &.capitalize{
        text-transform: capitalize;
    }
`;